<template>
  <div class="book-shelf-page">
    <AdminPageTitle :title="'Пользователи'" class="mt-10"/>
    <AppButton
      @click="showPersonForm=true"
      class="app-button n-admin-cource__add mt-8 mb-4 ml-4 mr-4"
    >
      <span>Добавить</span>
    </AppButton>
    <v-col cols=12>
      <v-text-field
        v-model="searchValue"
        label="Что ищем"
        variant="outlined"
        clearable
        v-on:click:clear="clearSearch()"
        rounded
      >
        <template v-slot:append>
          <v-icon
            icon="mdi-book-search-outline"
            @click="filterUsers()"
          ></v-icon>
        </template>
      </v-text-field>
    </v-col>

    <StateWrapper
      :content="data.persons"
      :loadingStatus="loadingStatus"
      :checkLogin="false"
    >
      <div class="wrapper">
        <div class="book-shelf-page__results">
          <div class="book-shelf-page__items" v-if="data.persons">
            <AccordionItemWithEdit
              v-for="(v, idx) in data.persons"
              :key="v.id"
              :isOpen="currentId === v.id"
              @open="setCurrentId"
              :style="{ 'animation-delay': `0.${idx}s` }"
              :id="v.id"
            >
              <template v-slot:top>
                <UserPreviewForList :person ="v"/>
              </template>
              <template v-slot:bottom>
                 <div class="user-avatar-settings">

                        <div class="user-avatar-settings__preview">
                          <AvatarWithCropper
                          :avatar="v.personAvatar"
                          :userId ="v.id"
                          @update="getUsers"
                        />
                      </div>
                      </div>
                <div class="ma-2">
                  <h4>Id:</h4>
                  <div class="book-shelf-page__chips">
                    <span>{{v.id}}</span>
                  </div>
                </div>

                <div class="ma-2">
                  <h4>E-mail:</h4>
                  <div class="book-shelf-page__chips">
                    <span>{{v.personEmail}}</span>
                  </div>
                </div>

                <div class="ma-2" v-if="v.personMobilePhone">
                  <h4>Телефон:</h4>
                  <div class="book-shelf-page__chips">
                    <span>{{v.personMobilePhone}}</span>
                  </div>
                </div>

                <div class="ma-2" v-if="v.birthday">
                  <h4>Дата рождения:</h4>
                  <div class="book-shelf-page__chips">
                    <span>{{v.birthday}}</span>
                  </div>
                </div>

                <div class="ma-2">
                  <h4>Согласие:</h4>
                  <div class="book-shelf-page__chips">
                    <span v-if="v.userPersonalDataAgree">Да</span>
                    <span v-else>Нет</span>
                  </div>
                </div>

                <div class="ma-2">
                  <h4>Рассылка:</h4>
                  <div class="book-shelf-page__chips">

                    <span v-if="v.notificationAgree">Да</span>
                    <span v-else>Нет</span>
                  </div>
                </div>
                <div class="ma-2">
                  <h4>Соглашение:</h4>

                  <div class="book-shelf-page__chips">
                    <span class="book-shelf-page__chips" v-if="v.userAgreement">Да</span>
                    <span v-else>Нет</span>
                  </div>
                </div>

                <div class="ma-2">
                  <h4>Учетная запись активна:</h4>
                  <div class="book-shelf-page__chips">
                    <span v-if="v.active">Да</span>
                    <span v-else>Нет</span>
                  </div>
                </div>
                <div class="ma-2">
                  <h4>Роли:</h4>
                  <div class="book-shelf-page__chips" v-if="v.roles && v.roles.length>0">
                    <span v-for="c in v.roles" :key="c" >
                      {{c}}</span>
                  </div>
                  <p v-else>Роли не добавлены</p>
                </div>


                <div class="ma-2"  >
                  <h4>Группы:</h4>
                  <div class="book-shelf-page__chips" v-if="v.personGroups && v.personGroups.length>0">
                    <span v-for="c in v.personGroups" :key="c">{{
                      c.personGroupName
                    }}</span>
                  </div>
                  <p v-else>Группы не добавлены</p>
                </div>

                <div class="ma-2">
                  <h4>Регалии:</h4>
                  <div>
                    <v-chip-group
                      class="v-chip--variant-tonal text-pink-lighten-3"
                      variant="tonal"
                      column>
                       <v-chip
                         label
                         variant="outlined"
                         append-icon="mdi-plus"
                         size="large"
                         :ripple="false"
                         class="v-chip--variant-tonal text-green-lighten-3"
                         @click="addUserRegalia(v)"
                       >
                        <span>Добавить регалию</span>
                       </v-chip>
                       <v-chip
                       variant="outlined"
                        class="short"
                        append-icon="mdi-tag"
                        label
                        size="large"
                        :ripple="false"
                        v-for="r in v.personRegalias" :key="r.id"
                        @click="editRegalia(r)"
                       >
                         <span>{{r.regaliaName}}</span>
                      </v-chip>
                    </v-chip-group>

                  </div>
                </div>


                <v-divider color="accent" class="mt-8"></v-divider>
                <div class="ma-2">
                  <v-row>
                    <v-spacer></v-spacer>
                    <AppButton
                      @click="deletePerson(v)"
                      class="app-button n-admin-cource__add mt-8 mb-4 ml-4 mr-4"
                    >
                      <span>Удалить</span>
                    </AppButton>
                    <AppButton
                      @click="editPerson(v)"
                      class="app-button n-admin-cource__add mt-8 mb-4 ml-4 mr-4"
                    >
                      <span>Редактировать</span>
                    </AppButton>
                  </v-row>
                </div>


              </template>
            </AccordionItemWithEdit>
          </div>

          <div class="flex flex__jc-c" v-if="!!data && data.usersCount ">
            <vue-awesome-paginate
              :total-items="data.usersCount"
              v-model="currentPage"
              :items-per-page="itemsPerPage"
              :max-pages-shown="maxPagesShown"
              @click=updateUsers()
            />
          </div>
        </div>
      </div>
    </StateWrapper>
    <v-dialog v-model="showPersonForm" scrollable>
      <v-card>
        <v-card-title class="card_ligth_header">
          <h5>Пользователь</h5>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="userForm">
            <v-container>
              <v-row>
                <v-alert class="ma-4" v-if="errorBody" :text="errorBody" type="error"></v-alert>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    label="Фамилия*"
                    v-model="lastname"
                    hint="Укажите фамилию"
                    :counter="50"
                    variant="outlined"
                    required
                  ></v-text-field>
                  <div
                    class="input-errors"
                    v-for="error of v$.lastname.$errors"
                    :key="error.$uid"
                  >
                    <div class="error-msg form__tip form__tip--error showing">
                      {{ error.$message }}
                    </div>
                  </div>
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    label="Имя*"
                    v-model="firstname"
                    :counter="50"
                    variant="outlined"
                    hint="Укажите имя"
                    required
                  ></v-text-field>
                  <div
                    class="input-errors"
                    v-for="error of v$.firstname.$errors"
                    :key="error.$uid"
                  >
                    <div class="error-msg form__tip form__tip--error showing">
                      {{ error.$message }}
                    </div>
                  </div>
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    label="Отчество*"
                    v-model="secname"
                    variant="outlined"
                    :counter="50"
                    hint="Укажите отчество"

                  ></v-text-field>

                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="personEmail"
                    variant="outlined"
                    label="Email*"
                    hint="Укажите e-mail"
                  ></v-text-field>
                  <div
                    class="input-errors"
                    v-for="error of v$.personEmail.$errors"
                    :key="error.$uid"
                  >
                    <div class="error-msg form__tip form__tip--error showing">
                      {{ error.$message }}
                    </div>
                  </div>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="password"
                    label="Пароль*"
                    contenteditable="false"
                    type="text"
                    variant="outlined"
                    hint="Сгенерированный пароль"
                    persistent
                  >
                    <template v-slot:append>
                      <v-icon
                        color="red"
                        @click="generatePassword()"
                      >
                        mdi-hammer
                      </v-icon>
                    </template>
                  </v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-autocomplete
                    v-model="roles"
                    :items="rolesItems"
                    outlined
                    dense
                    chips
                    small-chips
                    variant="outlined"
                    closable-chips
                    label="Роли"
                    multiple
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12">
                  <v-autocomplete
                    v-model="personGroups"
                    :items="userGroups"
                    :custom-filter="userGroupFilter"
                    filled
                    chips
                    small-chips
                    variant="outlined"
                    closable-chips
                    label="Группы пользователей"
                    item-title="name"
                    item-value="name"
                    multiple
                  >
                    <template v-slot:chip="{ props, item }">
                      <v-chip
                        v-bind="props"
                        :text="item.raw.personGroupName"
                      ></v-chip>
                    </template>
                    <template v-slot:item="{ props, item }">

                      <v-list-item

                        v-bind="props"
                        :title="item.raw.personGroupName"
                        :subtitle="item.raw.personGroupDescription"
                      ></v-list-item>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12">
                  <v-switch
                    v-model="active"
                    :label="active ? 'Активирован' : 'Не активирован'"
                    hide-details
                  >
                  </v-switch>
                </v-col>

              </v-row>
            </v-container>
            <small>*обязательно для заполнения</small>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="card_ligth_actions">
          <v-spacer></v-spacer>
          <AppButton
            class="app-button n-admin-cource__add mt-8 mb-4 ml-4 mr-4"
            @click="closePersonForm()"
          >
            <span>Отмена</span>
          </AppButton>
          <AppButton
            class="app-button n-admin-cource__add mt-8 mb-4 ml-4 mr-4"
            @click="savePerson()"
            :disabled="saveIsDisable"
          >
            <span>Сохранить</span>
          </AppButton>
        </v-card-actions>
      </v-card>

    </v-dialog>

    <v-dialog v-model="regaliaDialog" scrollable>
      <v-card>
        <v-card-title class="card_ligth_header">
          <h5>Регалии</h5>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="regaliaForm">
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    label="Название"
                    v-model="regaliaName"
                    hint="Укажите название"
                    :counter="250"
                    variant="outlined"
                    required
                  ></v-text-field>
                  <div
                    class="input-errors"
                    v-for="error of r$.regaliaName.$errors"
                    :key="error.$uid"
                  >
                    <div class="error-msg form__tip form__tip--error showing">
                      {{ error.$message }}
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" class="mb-16" style="height: 1200px;">
                  <TextEditor class="mb-3" :value="regaliaBody" @update:value="onRegaliaBodyUpdate" />
                  <div
                    class="input-errors"
                    v-for="error of r$.regaliaBody.$errors"
                    :key="error.$uid"
                  >
                    <div class="error-msg form__tip form__tip--error showing">
                      {{ error.$message }}
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-container>
            <small>*обязательно для заполнения</small>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="card_ligth_actions">
          <v-spacer></v-spacer>
          <AppButton v-if="id"
            class="app-button n-admin-cource__add mt-8 mb-4 ml-4 mr-4"
            @click="deleteRegalia(id)"
          >
            <span>Удалить</span>
          </AppButton>
          <AppButton
            class="app-button n-admin-cource__add mt-8 mb-4 ml-4 mr-4"
            @click="closeRegaliaDialog()"
          >
            <span>Отмена</span>
          </AppButton>
          <AppButton
            class="app-button n-admin-cource__add mt-8 mb-4 ml-4 mr-4"
            @click="saveRegalia()"
            :disabled="regaliaSaveIsDisable"
          >
            <span>Сохранить</span>
          </AppButton>
        </v-card-actions>
      </v-card>

    </v-dialog>

  </div>
</template>

<script>
import { onMounted, ref, computed } from "vue";
import TextEditor from "@/components/TextEditor.vue";
import { t } from "@/utils/translate";
import { customAxios } from "@/service/customAxios";
import AccordionItemWithEdit from "@/components/AccordionItemWithEdit.vue";
import AdminPageTitle from "@/elements/AdminPageTitle.vue";
import StateWrapper from "@/components/StateWrapper.vue";
import { setCurrentIdValue } from "@/utils/common";
import AppButton from "@/elements/AppButton.vue";
import { required, maxLength, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { usePopupStore } from "@/store/popupStore";
import UserPreviewForList from "@/components/UserPreviewForList.vue";
import AvatarWithCropper from "@/components/AvatarWithCropper.vue";


export default {
  components: {
    StateWrapper,
    AdminPageTitle,
    AccordionItemWithEdit,
    AppButton,
    UserPreviewForList,
    TextEditor,
    AvatarWithCropper
  },
  setup() {
    const regaliaName = ref("");
    const regaliaBody = ref("");
    const regaliaDialog = ref(false);
    const personId = ref();
    const regaliaId = ref();

    const lastname = ref("");
    const firstname = ref("");
    const secname = ref("");
    const personEmail = ref("");
    const birthday = ref("");
    const personMobilePhone = ref("");
    const password = ref("");
    const roles = ref([]);
    const userGroups = ref([]);
    const personGroups = ref([]);
    const active = ref(false);
    const showPersonForm = ref(false);
    const id = ref("");
    const errorBody = ref("");
    const { showPopup } = usePopupStore();
    const rolesItems = ref(['ROLE_USER', 'ROLE_ADMIN', 'ROLE_PARENT', 'ROLE_CHILD','ROLE_COACH', 'ROLE_TUTOR', 'ROLE_MASTER', 'ROLE_EXPERT']);
    const regaliaRules = {
      regaliaName: {
        required: helpers.withMessage("Обязательное поле", required),
        max: helpers.withMessage("Не более 250 символов", maxLength(250)),
      },
      regaliaBody: {
        required: helpers.withMessage("Обязательное поле", required)
      },
    }
    const r$ = useVuelidate(regaliaRules, {
      regaliaName: regaliaName,
      regaliaBody: regaliaBody
    });

    const rules = {
      lastname: {
        required: helpers.withMessage("Обязательное поле", required),
        max: helpers.withMessage("Не более 50 символов", maxLength(50)),
      },
      firstname: {
        required: helpers.withMessage("Обязательное поле", required),
        max: helpers.withMessage("Не более 50 символов", maxLength(50)),
      },
      personEmail: {
        required: helpers.withMessage("Обязательное поле", required),
        max: helpers.withMessage("Не более 50 символов", maxLength(50)),
      },
    };


    const v$ = useVuelidate(rules, {
      lastname: lastname,
      firstname: firstname,
      personEmail: personEmail,
    });


    const loadingStatus = ref("loading");
    const currentId = ref(null);
    const searchValue = ref(null);
    const data = ref([]);
    const maxPagesShown = ref(5);
    const itemsPerPage = ref(25);
    const currentPage = ref(1);
    const persons = ref([]);
    function setCurrentId(value) {
      currentId.value = setCurrentIdValue(value, currentId.value);
    }

    function userGroupFilter(item, queryText){

      const textPersonGroupName = item.personGroupName.toLowerCase()
      const textPersonGroupDescription = item.personGroupDescription.toLowerCase()

      const searchText = queryText.toLowerCase()


      return textPersonGroupName.indexOf(searchText) > -1 ||
        textPersonGroupDescription.indexOf(searchText) > -1

    }
    async function clearSearch(){
      searchValue.value=null;
      currentPage.value = 1;
      await updateUsers();
    }

    async function filterUsers(){
      currentPage.value = 1;
      await updateUsers();
    }

    const saveIsDisable = computed(() => {
      return checkInvalidation();
    });
    const regaliaSaveIsDisable = computed(() => {
      r$.value.$touch();
      return r$.value.$invalid;
    });

    function checkInvalidation() {
      v$.value.$touch();
      if(!id.value){
        return v$.value.$invalid ||
          !personEmail.value && personEmail.value.length<4 ||
          !password.value && password.value.length <10
      } else {
        return v$.value.$invalid;
      }

    }


    async function updateUsers(){
      data.value = await getUsers();
      persons.value = data.value.persons;
    }


    async function getUsers() {
      try {
        const r = await customAxios.post("person/paginated",{
          page: currentPage.value,
          notePerPage: itemsPerPage.value,
          reqString: searchValue.value

        });
        loadingStatus.value = "loaded";
        return r.data;
      } catch (e) {
        loadingStatus.value = "error";
        console.log(e);
      }
    }
    function capitalizeFirstLetter(string) {
      if(string && string.length>0){
        return string.charAt(0).toUpperCase() + string.slice(1);
      } else {
        return ''
      }
    }

    function editPerson(item) {
      console.log("editing person: " + item.id)
      lastname.value = item.lastname;
      firstname.value=item.firstname;
      secname.value=item.secname;
      personEmail.value=item.personEmail;
      birthday.value=item.birthday;
      personMobilePhone.value=item.personMobilePhone;
      password.value=item.password;
      roles.value=item.roles;
      userGroups.value=item.userGroups;
      active.value=item.active;
      showPersonForm.value=true;
      id.value=item.id;
    }

    function generatePassword() {
      let text = ""
      let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+-"

      for (var i = 0; i < 13; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length))
      password.value = text
    }
    function closePersonForm(){
      errorBody.value="";
      lastname.value="";
      firstname.value="";
      secname.value="";
      personEmail.value="";
      birthday.value="";
      personMobilePhone.value="";
      password.value="";
      roles.value=[];
      userGroups.value=[];
      personGroups.value=[];
      active.value=true;
      showPersonForm.value=false;
      id.value = "";
    }
    function addUserRegalia(v) {
      personId.value = v.id;
      regaliaDialog.value = true;
    }

    async function savePerson() {
      errorBody.value=''
      console.log("in save")

      let person = {
        firstname: capitalizeFirstLetter(firstname.value),
        lastname: capitalizeFirstLetter(lastname.value),
        secname: secname.value!=null ? capitalizeFirstLetter(secname.value) : '',
        personEmail: personEmail.value,
        password: password.value,
        active: active.value,
        roles: roles.value,
        personGroups: personGroups.value.map((v) => ({id: v.id})),
      }
      if (id.value) {
        try{
          const r = await customAxios.put('person/' + id.value, person)
          if(r.status===202){
            closePersonForm();
            updateUsers();
            showPopup("Пользователь успешно обновлен!", "success");
          }

        } catch (e) {
          if(e.response && e.response.data && e.response.data.message){
            errorBody.value = e.response.data.message;
          } else {
            errorBody.value = t("something.went.wrong");
          }
        }
      } else {
        try{
          const r = await  customAxios.post('person', person);
          if(r.status===201){
            closePersonForm();
            updateUsers();
            showPopup("Пользователь успешно обновлен!", "success");
          }
        } catch(e){
          if(e.response && e.response.data && e.response.data.message){
            errorBody.value = e.response.data.message;
          } else {
            errorBody.value = t("something.went.wrong");
          }
        }
      }
    }

    async function deletePerson(person){
      try {
        const r = await customAxios.delete('person/' + person.id)
        console.log("r: " + r);
        if(r.status===202){
          showPopup(r.data.message, "success");
          updateUsers();
        }

      } catch (e) {
        if(e.response && e.response.data && e.response.data.message){
          showPopup(e.response.data.message, "error");
        } else {
          showPopup(t("something.went.wrong"), "error");
        }
      }
    }

    function closeRegaliaDialog() {
      regaliaBody.value = "";
      regaliaName.value = "";
      id.value = undefined;
      personId.value = undefined;
      regaliaDialog.value = false;
    }

    async function saveRegalia() {

      let personRegalia = {
        regaliaName: capitalizeFirstLetter(regaliaName.value),
        regaliaBody: capitalizeFirstLetter(regaliaBody.value),
        personId: personId.value,
      }
      if (id.value) {
        try{
          const r = await customAxios.put('person/regalia/' + id.value, personRegalia)
          if(r.status===202){
            closeRegaliaDialog();
            updateUsers();
            showPopup("Пользовательские регалии успешно обновлены!", "success");
          }

        } catch (e) {
          if(e.response && e.response.data && e.response.data.message){
            errorBody.value = e.response.data.message;
          } else {
            errorBody.value = t("something.went.wrong");
          }
        }
      } else {
        try{
          const r = await  customAxios.post('person/regalia', personRegalia);
          if(r.status===201){
            closeRegaliaDialog();
            updateUsers();
            showPopup("Пользовательcкая  регалия успешно добавлена!", "success");
          }
        } catch(e){
          if(e.response && e.response.data && e.response.data.message){
            errorBody.value = e.response.data.message;
          } else {
            errorBody.value = t("something.went.wrong");
          }
        }
      }
    }
    async function deleteRegalia(id) {
      try {
        const r = await customAxios.delete('person/regalia/' + id)
        if (r.status === 202) {
          closeRegaliaDialog();
          updateUsers();
          showPopup("Пользовательская регалия успешно удалена!", "success");
        }

      } catch (e) {
        if (e.response && e.response.data && e.response.data.message) {
          errorBody.value = e.response.data.message;
        } else {
          errorBody.value = t("something.went.wrong");
        }
      }
    }

    onMounted(async () => {
      data.value = await getUsers();
    });
    function onRegaliaBodyUpdate(e) {
      regaliaBody.value = e;
    }
    function editRegalia(r) {
      id.value = r.id;
      regaliaName.value = r.regaliaName;
      regaliaBody.value = r.regaliaBody;
      personId.value = r.personId;
      regaliaDialog.value = true;
    }

    return {
      loadingStatus,
      itemsPerPage,
      currentPage,
      maxPagesShown,
      data,
      persons,
      regaliaSaveIsDisable,
      t,
      onRegaliaBodyUpdate,
      addUserRegalia,
      closeRegaliaDialog,
      saveRegalia,
      updateUsers,
      setCurrentId,
      deleteRegalia,
      currentId,
      lastname,
      firstname,
      secname,
      personEmail,
      birthday,
      personMobilePhone,
      password,
      roles,
      userGroups,
      active,
      showPersonForm,
      id,
      regaliaName,
      regaliaBody,
      regaliaDialog,
      personId,
      regaliaId,
      r$,
      editRegalia,
      editPerson,
      deletePerson,
      closePersonForm,
      generatePassword,
      savePerson,
      capitalizeFirstLetter,
      personGroups,
      userGroupFilter,
      rules,
      v$,
      saveIsDisable,
      rolesItems,
      errorBody,
      searchValue,
      clearSearch,
      filterUsers,
      getUsers

    };
  },
};
</script>

<style lang="scss">
.book-shelf-page {
  text-align: center;

  &__chips {
    margin-top: 5px;
    display: flex;
    flex-wrap: wrap;

    span {
      color: $accent-1;
      border: 1px dashed $accent-1;
      padding: 8px;
      margin: 8px;
      border-radius: 10px;
    }
  }

  &__filters {
    text-align: left;
    margin-bottom: 60px;
  }

  &__filters-title {
    margin-bottom: 10px;
  }

  &__theme {
    @include button-default-not-accent;
    display: none;
    margin-right: 8px;

    &.active {
      display: flex;
    }

    &.current {
      background-color: $accent-1;
      color: #fff;
    }
  }

  &__search {
    margin-bottom: 60px;
  }

  .wrapper {
    @include page;
  }
  ul{
    margin-left: 40px;
  }

  &__items {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 40px;
    width: 100%;
    margin: 0 auto;
    margin-top: 30px;
  }

  &__btn {
    @include button-default-not-accent;

    &.active {
      @include button-default;
    }

    & + .book-shelf-page__btn {
      margin-left: 16px;
    }
  }
}
</style>